import { frontendURL } from 'dashboard/helper/URLHelper.js';
import CampaignPlansPage from './CampaignPlansPage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/campaign-plans'),
      name: 'campaign_plans_list',
      component: CampaignPlansPage,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};

